var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding01Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 34",
    style: {
      enableBackground: "new 0 0 28 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0{fill:#FFFFFF;}\n        .st1{fill:none;stroke:#010202;strokeWidth:1.0337;stroke-miterlimit:1.5801;}\n        .st2{fill:#BEE8FF;}\n        .st3{fill:none;stroke:#010202;strokeWidth:1.0879;stroke-miterlimit:1.5801;}\n        .st4{fill:none;stroke:#FFFFFF;strokeWidth:1.0337;stroke-miterlimit:1.5801;}\n        .st5{fill:none;stroke:#FFFFFF;strokeWidth:1.0879;stroke-miterlimit:1.5801;}\n        .st6{fill:none;stroke:#010202;strokeWidth:0.9604;stroke-miterlimit:1.5801;}\n        .st7{fill:none;stroke:#010202;strokeWidth:1.0459;stroke-miterlimit:1.5801;}\n        .st8{fill:none;stroke:#010202;strokeWidth:0.9658;stroke-miterlimit:1.5801;}\n        .st9{fill:#FFFFFF;stroke:#010202;strokeWidth:1.008;stroke-miterlimit:1.5801;}\n        .st10{fill:none;stroke:#010202;strokeWidth:1.008;stroke-miterlimit:1.5801;}\n        .st11{fill:none;stroke:#010202;strokeWidth:0.9387;stroke-miterlimit:1.5801;}\n        .st12{fill:none;stroke:#010202;strokeWidth:0.9831;stroke-miterlimit:1.5801;}\n        .st13{fill:none;stroke:#FFFFFF;strokeWidth:0.9604;stroke-miterlimit:1.5801;}\n        .st14{fill:none;stroke:#FFFFFF;strokeWidth:1.0459;stroke-miterlimit:1.5801;}\n        .st15{fill:none;stroke:#FFFFFF;strokeWidth:0.9658;stroke-miterlimit:1.5801;}\n        .st16{fill:none;stroke:#FFFFFF;strokeWidth:1.008;stroke-miterlimit:1.5801;}\n        .st17{fill:none;stroke:#FFFFFF;strokeWidth:0.9387;stroke-miterlimit:1.5801;}\n        .st18{fill:none;stroke:#FFFFFF;strokeWidth:0.9831;stroke-miterlimit:1.5801;}\n        .st19{fill:#010202;}\n        .st20{opacity:0.129;}\n        .st21{fill:none;stroke:#010202;strokeWidth:0.4807;stroke-miterlimit:1.5801;}\n        .st22{fill:none;stroke:#010202;strokeWidth:0.5086;stroke-miterlimit:1.5801;}\n        .st23{fill:none;stroke:#FFFFFF;strokeWidth:0.4807;stroke-miterlimit:1.5801;}\n        .st24{fill:#FFFFFF;stroke:#FFFFFF;strokeWidth:0.5086;stroke-miterlimit:1.5801;}\n        .st25{fill:#FFFFFF;stroke:#040505;strokeWidth:0.9862;stroke-miterlimit:1.5801;}\n        .st26{fill:#FFFFFF;stroke:#040505;strokeWidth:1.1145;stroke-miterlimit:1.5801;}\n        .st27{fill:none;stroke:#FFFFFF;strokeWidth:0.9862;stroke-miterlimit:1.5801;}\n        .st28{fill:none;stroke:#FFFFFF;strokeWidth:1.1145;stroke-miterlimit:1.5801;}\n        .st29{fill:#84CEEF;}\n        .st30{fill:none;stroke:#FFFFFF;strokeWidth:1.8618;stroke-miterlimit:1.5801;}\n        .st31{fill:none;stroke:#FFFFFF;strokeWidth:1.8618;stroke-miterlimit:1.5802;}\n        .st32{fill:none;stroke:#FFFFFF;strokeWidth:1.862;stroke-miterlimit:1.5803;}\n        .st33{fill:none;stroke:#010202;strokeWidth:0.9309;stroke-miterlimit:1.5801;}\n        .st34{fill:none;stroke:#040506;strokeWidth:0.7823;stroke-miterlimit:1.2598;}\n        .st35{fill:none;stroke:#040505;strokeWidth:0.7823;stroke-miterlimit:1.2598;}\n        .st36{fill:#040505;}\n        .st37{fill:none;stroke:#FFFFFF;strokeWidth:0.9309;stroke-miterlimit:1.5801;}\n        .st38{fill:none;stroke:#FFFFFF;strokeWidth:0.7823;stroke-miterlimit:1.2598;}\n        .st39{opacity:0.1294;}\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.06,14.78v4.09c-0.01,0.09-0.08,0.16-0.16,0.16H7.32c-0.09,0-0.16-0.07-0.16-0.16v-4.09    c0-0.09,0.07-0.16,0.16-0.16H9.9C9.99,14.62,10.06,14.69,10.06,14.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.06,23.81v4.09c-0.01,0.09-0.08,0.16-0.16,0.16H7.32c-0.09,0-0.16-0.07-0.16-0.16v-4.09    c0-0.09,0.07-0.16,0.16-0.16H9.9C9.99,23.65,10.06,23.72,10.06,23.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.24,5.75v4.09C10.23,9.93,10.16,10,10.07,10H7.5c-0.09,0-0.16-0.07-0.16-0.16V5.75    c0-0.09,0.07-0.16,0.16-0.16h2.58C10.17,5.59,10.24,5.66,10.24,5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.52,14.78v4.09c0,0.09-0.07,0.16-0.16,0.16h-2.58c-0.09,0-0.16-0.07-0.16-0.16v-4.09    c0-0.09,0.07-0.16,0.16-0.16h2.58C15.45,14.62,15.52,14.69,15.52,14.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.52,23.81v4.09c0,0.09-0.07,0.16-0.16,0.16h-2.58c-0.09,0-0.16-0.07-0.16-0.16v-4.09    c0-0.09,0.07-0.16,0.16-0.16h2.58C15.45,23.65,15.52,23.72,15.52,23.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,5.75v4.09c0,0.09-0.07,0.16-0.16,0.16h-2.58c-0.09,0-0.16-0.07-0.16-0.16V5.75    c0-0.09,0.07-0.16,0.16-0.16h2.58C15.63,5.59,15.7,5.66,15.7,5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.66,14.78v4.09c0,0.09-0.07,0.16-0.16,0.16h-2.58c-0.09,0-0.16-0.07-0.16-0.16v-4.09    c0-0.09,0.07-0.16,0.16-0.16h2.58C20.59,14.62,20.66,14.69,20.66,14.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.66,23.81v4.09c0,0.09-0.07,0.16-0.16,0.16h-2.58c-0.09,0-0.16-0.07-0.16-0.16v-4.09    c0-0.09,0.07-0.16,0.16-0.16h2.58C20.59,23.65,20.66,23.72,20.66,23.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.84,5.75v4.09c0,0.09-0.07,0.16-0.16,0.16H18.1c-0.09,0-0.16-0.07-0.16-0.16V5.75    c0-0.09,0.07-0.16,0.16-0.16h2.58C20.77,5.59,20.84,5.66,20.84,5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.21,0.16L4.77,33.84h18.24l0.22-33.68H5.21z M22.86,33.69H4.93L5.36,0.31h17.72L22.86,33.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.34,0.05C23.31,0.02,23.27,0,23.23,0H5.21C5.12,0,5.05,0.07,5.05,0.15L4.62,33.84    c-0.01,0.04,0.01,0.08,0.04,0.11C4.69,33.98,4.73,34,4.77,34h18.24c0.09,0,0.16-0.07,0.16-0.15l0.22-33.69    C23.39,0.12,23.37,0.08,23.34,0.05z M4.93,33.69L5.36,0.31h17.72l-0.22,33.38H4.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.49,
    y: 5.75,
    className: "st2",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.08,5.59H7.5c-0.09,0-0.16,0.07-0.16,0.16v4.09C7.34,9.93,7.41,10,7.5,10h2.57c0.09,0,0.16-0.07,0.17-0.16    V5.75C10.24,5.66,10.17,5.59,10.08,5.59z M9.92,9.69H7.65V5.91h2.27V9.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.95,
    y: 5.75,
    className: "st2",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.54,5.59h-2.58c-0.09,0-0.16,0.07-0.16,0.16v4.09c0,0.09,0.07,0.16,0.16,0.16h2.58    c0.09,0,0.16-0.07,0.16-0.16V5.75C15.7,5.66,15.63,5.59,15.54,5.59z M15.38,9.69h-2.26V5.91h2.26V9.69z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.31,
    y: 14.78,
    className: "st2",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,14.62H7.32c-0.09,0-0.16,0.07-0.16,0.16v4.09c0,0.09,0.07,0.16,0.16,0.16H9.9c0.08,0,0.15-0.07,0.16-0.16   v-4.09C10.06,14.69,9.99,14.62,9.9,14.62z M9.73,18.72H7.47v-3.78h2.26V18.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.78,
    y: 14.78,
    className: "st2",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.36,14.62h-2.58c-0.09,0-0.16,0.07-0.16,0.16v4.09c0,0.09,0.07,0.16,0.16,0.16h2.58    c0.09,0,0.16-0.07,0.16-0.16v-4.09C15.52,14.69,15.45,14.62,15.36,14.62z M15.2,18.72h-2.26v-3.78h2.26V18.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.31,
    y: 23.81,
    className: "st2",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,23.65H7.32c-0.09,0-0.16,0.07-0.16,0.16v4.09c0,0.09,0.07,0.16,0.16,0.16H9.9    c0.08,0,0.15-0.07,0.16-0.16v-4.09C10.06,23.72,9.99,23.65,9.9,23.65z M9.73,27.74H7.47v-3.78h2.26V27.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.78,
    y: 23.81,
    className: "st2",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.36,23.65h-2.58c-0.09,0-0.16,0.07-0.16,0.16v4.09c0,0.09,0.07,0.16,0.16,0.16h2.58    c0.09,0,0.16-0.07,0.16-0.16v-4.09C15.52,23.72,15.45,23.65,15.36,23.65z M15.2,27.74h-2.26v-3.78h2.26V27.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.09,
    y: 5.75,
    className: "st2",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.68,5.59H18.1c-0.09,0-0.16,0.07-0.16,0.16v4.09c0,0.09,0.07,0.16,0.16,0.16h2.58    c0.09,0,0.16-0.07,0.16-0.16V5.75C20.84,5.66,20.77,5.59,20.68,5.59z M20.52,9.69h-2.26V5.91h2.26V9.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.92,
    y: 14.78,
    className: "st2",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,14.62h-2.58c-0.09,0-0.16,0.07-0.16,0.16v4.09c0,0.09,0.07,0.16,0.16,0.16h2.58    c0.09,0,0.16-0.07,0.16-0.16v-4.09C20.66,14.69,20.59,14.62,20.5,14.62z M20.34,18.72h-2.26v-3.78h2.26V18.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.92,
    y: 23.81,
    className: "st2",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,23.65h-2.58c-0.09,0-0.16,0.07-0.16,0.16v4.09c0,0.09,0.07,0.16,0.16,0.16h2.58    c0.09,0,0.16-0.07,0.16-0.16v-4.09C20.66,23.72,20.59,23.65,20.5,23.65z M20.34,27.74h-2.26v-3.78h2.26V27.74z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding01Dark);
export default __webpack_public_path__ + "static/media/Building-01Dark.e91ef01feba4d0464fb98ddcfa5103c9.svg";
export { ForwardRef as ReactComponent };